module.exports = __webpack_public_path__ + "img/mobile-7.67a8fb95.png";